import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEditButton } from '../../hooks/notes/use_edit_button';
import { styled } from '../../styles';
import { AppIcon } from '../icons/app_icon';
import AppText from '../typography/app_text';
export function EditButton({ inCallOrPostCall }) {
    const { onClick, readOnlyYn } = useEditButton();
    return (_jsxs(Button, { onClick: onClick, disabled: readOnlyYn, inCallOrPostCall: inCallOrPostCall, "data-testid": "notes-edit-button", children: [_jsx(AppIcon, { name: "SquareAndPencilIcon", color: readOnlyYn ? 'grey30' : 'blue50' }), _jsx(AppText, { color: readOnlyYn ? 'grey30' : 'blue50', children: "Edit" })] }));
}
const Button = styled.button(({ theme, disabled, inCallOrPostCall }) => ({
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: '.25rem',
    color: inCallOrPostCall === 'post-call' ? theme.colors.blue50 : theme.colors.grey90,
    backgroundColor: inCallOrPostCall === 'post-call' ? theme.colors.white : 'inherit',
    border: 'none',
    borderRadius: '1.25rem',
    fontWeight: '500',
    fontSize: theme.text.size.medium,
    height: theme.iconButtonSizes.medium,
    padding: '0 1rem',
    transition: 'background-color 300ms linear',
    ':hover': {
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: disabled ? 'none' : theme.colors.grey10,
    },
}));
//# sourceMappingURL=edit_button.js.map